const get = require("lodash/get");
const { RangeSelectPrototype } = require("./prototypes");

function BmiType() {
  this.type = "bmi";

  this.validate = ({ eligibility, answer }) => {
    const min = get(eligibility, "min", 0);
    const max = get(eligibility, "max", Number.MAX_SAFE_INTEGER);
    return Number(answer) >= Number(min) && Number(answer) <= Number(max);
  };
}
BmiType.prototype = RangeSelectPrototype;

module.exports = BmiType;
